import { FirebaseOptions } from '@firebase/app';
import firebaseConfigJson from './firebase-config.json';

interface FirebaseConfig {
  options: FirebaseOptions;
  vapidKey: string;
}

export const firebaseConfig: FirebaseConfig = firebaseConfigJson;
